/** Only Telegram-confirmed message IDs returned by appMessagesManager.sendText. */
export function confirmedSentMessageId(receipt: unknown): string | undefined {
  if(!Array.isArray(receipt)) return undefined;
  for(const item of receipt) {
    if(typeof item === 'string' && /^[1-9][0-9]*$/.test(item)) return item;
    const nested = confirmedSentMessageId(item);
    if(nested) return nested;
  }
  return undefined;
}
